module.exports = __webpack_public_path__ + "img/plus-violet.848fb433.svg";